import { processActionErrors, forcedLogout } from '../../utils';
import toast from '../../helpers/toast';

const getErrorHost = (data = {}) => {
  let host = '';

  if (data.config && data.config.url) {
    const [pureLink] = data.config.url.split('?');
    const [, hostOne, hostTwo] = pureLink.split('/');

    if (hostTwo) {
      host = hostTwo;
    } else {
      host = hostOne;
    }
  }

  host = host.replace('-', ' ');

  return host;
};

const errorHandlerInit = () => {
  const errorHandler = () => {
    return (next) =>
      (action = {}) => {
        const { type = '', data = null } = action;

        if (type && type.endsWith('_FAILURE') && data) {
          if (
            data.response &&
            data.response.data &&
            data.response.data.message &&
            data.response.data.message === 'Unauthorized'
          ) {
            forcedLogout();
            return;
          }

          const processedMessage = processActionErrors(data);
          let toastMessage = processedMessage;
          const errorHost = getErrorHost(data);

          if (errorHost && errorHost.trim() !== '') {
            toastMessage = `${errorHost}: ${toastMessage}`;
          }

          toast.error(toastMessage);
          action.message = processedMessage;
        }

        next(action);
      };
  };

  return errorHandler;
};

export default errorHandlerInit;
